import { LocalStorage } from '../data/localstorage'

export class AppUtils {

    getWorkingDays(): any[] {
        return [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
            "Holiday"
        ]
    }

    getUserAccess(permission: string): boolean {
        const retval = new LocalStorage().userPermissions.find(
            (userPermission: { id: string; }) => userPermission.id == permission
        );
        return retval ? true : false;
    }
}